module.exports = new __parcel__URL__("the-incredibles.53bf004a.jpg").toString();